import { Dot, Wrapper } from './styles'
import { SpinnerProps } from './types'

function Spinner({ color = '#000000' }: SpinnerProps) {
  return (
    <Wrapper>
      <Dot color={color} />
      <Dot color={color} />
    </Wrapper>
  )
}

export default Spinner
